import React from 'react';
import { isMastheadCategoryMenu } from '../../../../../../utils/contentful';
import { ContentfulCategoryMenu, } from '../../../../FlyoutMenu/MenuLayouts/CategoryMenu/ContentfulCategoryMenu';
import { trackCat } from '../../../constants';
import { ContentfulGalleryMenu, } from '../../../../FlyoutMenu/MenuLayouts/GalleryMenu/ContentfulGalleryMenu';
import { useActiveSubmenu } from '../../../../../ActiveSubmenu/ActiveSubmenuProvider';
import { useS4XMastheadContext } from '../../../../../S4XMastheadProvider';
import { NavText } from '../../../../NavText';
export var SubmenuTrigger = function (_a) {
    var id = _a.id, label = _a.label;
    var InteractiveElement = useS4XMastheadContext().InteractiveElement;
    var claimActiveSubmenu = useActiveSubmenu(id).claimActiveSubmenu;
    return (React.createElement(InteractiveElement, { customComponent: NavText, id: id, trackingLabel: label, trackingCategory: trackCat, label: label, size: "xlarge", onClick: claimActiveSubmenu, svgIcon: "IconChevronRight", fullWidth: true }));
};
export var SubMenu = function (_a) {
    var activeItem = _a.activeItem, _b = _a.onNavigate, onNavigate = _b === void 0 ? function () { } : _b;
    return (React.createElement(React.Fragment, null, isMastheadCategoryMenu(activeItem) ? (React.createElement(ContentfulCategoryMenu, { activeItem: activeItem, onNavigate: onNavigate, trackCat: trackCat })) : (React.createElement(ContentfulGalleryMenu, { activeItem: activeItem, onNavigate: onNavigate, trackCat: trackCat }))));
};
